module.exports = __webpack_public_path__ + "img/other_xiaomi3.bf98c309.jpg";